import FormUpdateBankAccount from "@components/inputs/FormUpdateBankAccount";
import OnboardingDialogLayout from "@components/layouts/Onboarding/components/OnboardDialogLayout";
import { OnboardingDialogStep } from "@components/utils/OnboardingDialog/constants/onboarding-steps";
import { OnboardingStepProps } from "@components/utils/OnboardingDialog/types";
import { closeOnboardingDialog } from "@components/utils/OnboardingDialog/utils";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

interface BankAccountFormProps extends OnboardingStepProps {
  onUpdateSuccess?: () => void;
  step?: OnboardingDialogStep;
}

const BankAccountForm = ({ onUpdateSuccess, handleClose, layout, step }: BankAccountFormProps) => {
  const { t } = useTranslation();

  const handleOnUpdateSuccess = useCallback(() => {
    closeOnboardingDialog();
    onUpdateSuccess?.();
  }, [onUpdateSuccess]);

  return (
    <OnboardingDialogLayout
      layout={layout}
      drawerTitle={t(step === OnboardingDialogStep.UpdateBankAccount ? "bank account" : "register")}
      drawerSubTitle={t("Enter bank account details")}
      pageTitle={t("register")}
      pageSubTitle={t("Enter bank account details")}
      navigation={{
        close: {
          onClick: handleClose,
        },
      }}
      features={{
        showCloseButton: true,
      }}
    >
      <FormUpdateBankAccount
        onUpdateSuccess={handleOnUpdateSuccess}
        className="w-full"
        mode={step === OnboardingDialogStep.UpdateBankAccount ? "update" : "add"}
      />
    </OnboardingDialogLayout>
  );
};

export default BankAccountForm;
